export type UploadSectionFilesResult =
  | { status: 'uploaded'; assetIds: string[] }
  | { status: 'failed'; error: unknown };

/**
 * Turns validated files into the `assetIds` a `file` section persists.
 *
 * The ids APPEND to what the field already holds, because a section accumulates attachments
 * across several trips to the file picker; replacing them would silently drop everything
 * attached before this batch.
 *
 * A single rejection fails the whole batch and yields no ids at all. Returning the ones that
 * did land would write a list that looks complete while quietly missing files, and the person
 * would have no way to tell which of the two happened. Assets created by the siblings of a
 * failed upload are simply never referenced.
 */
export async function uploadSectionFiles(
  existingAssetIds: string[],
  files: File[],
  upload: (file: File) => Promise<{ id: string }>,
): Promise<UploadSectionFilesResult> {
  try {
    const uploaded = await Promise.all(files.map(upload));
    return { status: 'uploaded', assetIds: [...existingAssetIds, ...uploaded.map((a) => a.id)] };
  } catch (error) {
    return { status: 'failed', error };
  }
}
